import type { ServiceOrder } from '#domain/ServiceOrder.ts';

import type { OrderDialogState } from './OrderDialog.tsx';
import type { ServiceOrderFormData } from './ServiceOrderFormValidation.ts';
import { splitDateTimeValue } from './timeWindowFields.ts';

export const requiresLegacyServiceTypeReclassification = (
    state: OrderDialogState,
    existingCategory?: string,
    selectedCategory?: string
) =>
    (state === 'editOrder' || state === 'duplicateOrder') &&
    existingCategory === 'fueling-or-charging' &&
    selectedCategory !== 'fueling' &&
    selectedCategory !== 'charging';

const getServiceType = (order?: ServiceOrder): ServiceOrderFormData['serviceType'] => order?.category || 'other';

export const getServiceOrderFormDefaultValues = (
    state: OrderDialogState,
    order?: ServiceOrder
): ServiceOrderFormData => {
    const sourceOrder = state === 'createOrder' ? undefined : order;
    const duplicate = state === 'duplicateOrder';
    const startTarget = duplicate ? { date: '', time: '' } : splitDateTimeValue(sourceOrder?.executionStop.startTarget);
    const endTarget = duplicate ? { date: '', time: '' } : splitDateTimeValue(sourceOrder?.executionStop.endTarget);
    const serviceType = getServiceType(sourceOrder);
    return {
        serviceType,
        company: sourceOrder?.company,
        description: sourceOrder?.description ?? '',
        note: sourceOrder?.note,
        executionStop: {
            name: serviceType,
            location: {
                street: sourceOrder?.executionStop.location.street ?? '',
                city: sourceOrder?.executionStop.location.city ?? '',
                zipCode: sourceOrder?.executionStop.location.zipCode ?? '',
                country: sourceOrder?.executionStop.location.country ?? '',
            },
            startDate: startTarget.date,
            startTime: startTarget.time,
            endDate: endTarget.date,
            endTime: endTarget.time,
            latitude: sourceOrder?.executionStop.latitude ? Number(sourceOrder.executionStop.latitude) : undefined,
            longitude: sourceOrder?.executionStop.longitude ? Number(sourceOrder.executionStop.longitude) : undefined,
        },
    };
};
